import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          {/* 404 Error Code */}
          <h1 className="text-9xl font-bold text-gray-200">404</h1>
          
          {/* Error Message */}
          <h2 className="text-2xl font-semibold text-gray-900 mt-4">
            {t('notFound.title')}
          </h2>
          <p className="text-gray-600 mt-2">
            {t('notFound.message')}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            {t('notFound.goBack')}
          </Button>
          
          <Button
            onClick={() => navigate('/')}
            className="flex items-center gap-2"
          >
            <Home className="h-4 w-4" />
            {t('notFound.goHome')}
          </Button>
        </div>

        {/* Additional Help Text */}
        <p className="text-sm text-gray-500 mt-8">
          {t('notFound.helpText')}
        </p>
      </div>
    </div>
  );
}